/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { LawSchoolEntity } from '@axiom/domain';
/**
 * Response projection of the LawSchool entity. Extends LawSchoolEntity
 * (inherits `static key = 'LawSchool'`), so this projection and the full
 * LawSchool entity merge into the same normalized cache record.
 * dark-roast DTO: LawSchoolSearchResultDto
 */
export class ReadLawSchoolsResponseEntity extends LawSchoolEntity {
}